import { render, staticRenderFns } from "./illustrator.vue?vue&type=template&id=82b27e9c&"
import script from "./illustrator.vue?vue&type=script&lang=js&"
export * from "./illustrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports